import React, { useState, useEffect } from 'react'
import ButtonLoading from '../ButtonLoading'
import { userRequest } from '../../utils/requestMethods';

const AddSubjectModal = ({ closeModal, schoolId, classId, goback, onSubjectCreated }) => {
  const [subjectName, setSubjectName] = useState("");
  const [subjectDescription, setSubjectDescription] = useState("");
  const [passMark, setPassMark] = useState(50);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [groupings, setGroupings] = useState([]);
  const [selectedGrouping, setSelectedGrouping] = useState("");
  const [newGroupingName, setNewGroupingName] = useState("");
  const [newGroupingDesc, setNewGroupingDesc] = useState("");
  const [groupingLoading, setGroupingLoading] = useState(false);
  const [groupingError, setGroupingError] = useState("");

  useEffect(() => {
    const fetchGroupings = async () => {
      try {
        const { data } = await userRequest.get(`/subjects/groupings/${schoolId}`);
        setGroupings(data);
      } catch (err) {
        setGroupings([]);
      }
    };
    if (schoolId) fetchGroupings();
  }, [schoolId]);

  const handleAddGrouping = async (e) => {
    e.preventDefault();
    if (!newGroupingName) return setGroupingError("Grouping name required");
    setGroupingLoading(true);
    setGroupingError("");
    try {
      const { data } = await userRequest.post(`/subjects/groupings/${schoolId}`, {
        name: newGroupingName,
        //description: newGroupingDesc
      });
      setGroupings(prev => [...prev, data]);
      setSelectedGrouping(data._id);
      setNewGroupingName("");
      setNewGroupingDesc("");
    } catch (err) {
      setGroupingError(err?.response?.data || "Failed to add grouping");
    }
    setGroupingLoading(false);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!subjectName) {
      setError("Please Fill all the Feilds");
      setTimeout(() => {
        setError("");
      }, 5000);
      setLoading(false);
      return;
    }
    try {
      const payload = {
        schoolId: schoolId,
        classId: classId,
        subject_name: subjectName,
        pass_mark: passMark,
      };
      if (subjectDescription) {
        payload.subject_description = subjectDescription;
      }
      if (selectedGrouping) {
        payload.subject_group_id = selectedGrouping;
      }
      await userRequest.post("/subjects", payload);
      //console.log(data);
      onSubjectCreated();
      closeModal();
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        setSubjectName("");
        setSubjectDescription("");
        setPassMark(50);
        setSelectedGrouping("");
      }, 2000);
    } catch (error) {
      console.log(error);
      setError(error.response.data);
      setTimeout(() => {
        setError("");
      }, 5000);
      setLoading(false);
    }
    setLoading(false);
  };

  return(
    <div className="mt-4">
      <p className="text-sm text-gray-500 mt-2">
        Enter subject details
      </p>
      <div className="mt-3">
        {error &&
        <div className="p-4 mb-4 text-sm text-white rounded-lg bg-red-500" role="alert">
            <span className="font-medium">Error!</span> {error}
        </div>}
        {success &&
        <div className="p-4 mb-4 text-sm text-white rounded-lg bg-green-500" role="alert">
          <span className="font-medium">Success!</span> New Subject Added
        </div>}
        <form onSubmit={submitHandler} className="space-y-4">
          <div>
            <label htmlFor="subjectName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
            <input type="text" id="subjectName" onChange={(e) => setSubjectName(e.target.value)} value={subjectName} placeholder="Name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" required />
          </div>
          <div>
            <label htmlFor="lastName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Description <small>(Optional)</small></label>
            <textarea type="text" id="subject_description" onChange={(e) => setSubjectDescription(e.target.value)} value={subjectDescription} placeholder="Description" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"></textarea>
          </div>
          <div>
            <label htmlFor="passMark" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Pass Mark <small>(Required)</small></label>
            <input 
              type="number" 
              id="passMark" 
              min="0" 
              max="100" 
              onChange={(e) => setPassMark(parseInt(e.target.value) || 0)} 
              value={passMark} 
              placeholder="50" 
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" 
              required 
            />
            <p className="mt-1 text-xs text-gray-500">Enter the minimum score required to pass this subject (0-100)</p>
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Subject Grouping <small>(Optional)</small></label>
            <select
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
              value={selectedGrouping}
              onChange={e => setSelectedGrouping(e.target.value)}
            >
              <option value="">Select Grouping</option>
              {groupings.map(g => (
                <option key={g._id} value={g._id}>{g.name}</option>
              ))}
            </select>
            <div className="mt-2">
              <details>
                <summary className="cursor-pointer text-blue-600 text-sm">+ Add New Grouping</summary>
                <div className="mt-2 space-y-2">
                  <input type="text" placeholder="Grouping Name" value={newGroupingName} onChange={e => setNewGroupingName(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />
                  {/*<input type="text" placeholder="Description (optional)" value={newGroupingDesc} onChange={e => setNewGroupingDesc(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" />*/}
                  {groupingError && <div className="text-red-500 text-xs">{groupingError}</div>}
                  <button type="button" className="bg-blue-600 text-white rounded px-3 py-1 text-sm" disabled={groupingLoading} onClick={handleAddGrouping}>{groupingLoading ? 'Adding...' : 'Add Grouping'}</button>
                </div>
              </details>
            </div>
          </div>
          <div className="flex justify-between items-center">
            <button type="button" onClick={goback} className="text-gray-600 bg-white border border-gray-300 font-semibold rounded-full text-sm px-5 py-2 mr-3">&larr; Back</button>
            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center">
                {loading ? 'Adding...' : 'Add Subject'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default AddSubjectModal